import * as types from '../actions/types';

const initState = {
    data: null,
    loading: false,
    loadingError: null,
};

export default function LeaderboardReducer (state = initState, action) {

    switch (action.type)
    {
        case types.LEADERBOARD_LIST:
            return {...state, data: null,  loading: true, loadingError: null };

        case types.LEADERBOARD_LIST_SUCCESS:
            return {...state, data: action.payload, loading: false, loadingError: null };

        case types.LEADERBOARD_LIST_ERROR:
            return {...initState, loadingError: action.payload };

        default:
            return state;
    }

}
